"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("./hooks");

require("./SnackBarToast.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SnackBarToast = function SnackBarToast(_ref) {
  var type = _ref.type,
      message = _ref.message,
      onClose = _ref.onClose,
      onDismiss = _ref.onDismiss,
      position = _ref.position,
      btnLabel = _ref.btnLabel,
      btnComponent = _ref.btnComponent,
      timeout = _ref.timeout;

  var _useOpenAndDismiss = (0, _hooks.useOpenAndDismiss)(onClose, onDismiss, timeout),
      _useOpenAndDismiss2 = _slicedToArray(_useOpenAndDismiss, 2),
      isOpen = _useOpenAndDismiss2[0],
      dismissToast = _useOpenAndDismiss2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-sidebar-toast-wrapper' + (isOpen ? ' open' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-sidebar-toast ".concat(position.includes('Right') ? 'right' : 'left', " ").concat(type)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-sidebar-toast-msg"
  }, message), /*#__PURE__*/_react["default"].createElement("div", null, btnComponent != null ? /*#__PURE__*/_react["default"].cloneElement(btnComponent, {
    onClick: dismissToast
  }) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "tertiary",
    alt: true,
    onClick: dismissToast
  }, btnLabel))));
};

SnackBarToast.propTypes = {
  message: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  onDismiss: _propTypes["default"].func,
  btnLabel: _propTypes["default"].string,
  btnComponent: _propTypes["default"].element,
  timeout: _propTypes["default"].number,
  type: _propTypes["default"].oneOf(['dark', 'light']),
  position: _propTypes["default"].oneOf(['topLeft', 'topRight', 'bottomLeft', 'bottomRight']).isRequired
};
SnackBarToast.defaultProps = {
  type: 'dark',
  timeout: 3000
};
var _default = SnackBarToast;
exports["default"] = _default;